import type { FaireProductEntity } from "../../entity_types/product";

export const p_musq843yg5: FaireProductEntity = {
  token: "p_musq843yg5",
  type: "product",
  name: "Gold Snake Chain Pendant Necklace",
  brandToken: "b_xju99kcstz",
  brandName: "paperln",
  imageUrl:
    "https://cdn.faire.com/fastly/f5a6e695aaa41b6d3df5e0bded85cd9aef9163baceed43978f2049f536d0e528.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d20a28e61d22d5ad3321921d639dc3e67be76b6c90ceb60e18f838d7ae8e4c1e.jpeg",
  ],
  priceDollars: 11.63,
  description:
    "Elevate your style with this exquisite Gold Snake Chain Pendant Necklace, perfect for adding a touch of elegance to any outfit. \n\nFeatures:\n- Sleek and sophisticated snake chain design\n- Durable gold plating for a luxurious finish\n- Versatile pendant adds a unique flair\n\nMaterials:\n- High-quality gold-plated metal\n- Hypoallergenic and nickel-free\n\nSeasonality:\n- Ideal for year-round wear, from casual outings to formal events\n\nStyling Suggestions:\n- Pair with a simple blouse for a chic look\n- Layer with other necklaces for a trendy vibe\n\nCare Instructions:\n- Avoid exposure to water and chemicals\n- Clean gently with a soft cloth to maintain shine",
  tags: [],
  msrpDollars: 23.25,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:50:02.273Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
